import loadable from "@loadable/component";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router";
import usePatchHook from "../../customHooks/usePatchHook";
import useGetHook from "../../customHooks/useGetHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const EditCountryComponent = loadable(
  () => import("../../components/Country/EditCountry")
);
const EditCountry = () => {
  const { id } = useParams();

  const { data, refetch } = useGetHook({
    queryKey: [`country-${id}`],
    url: `${APIS.LOCATION}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: ["Country"],
    navigateURL: "/country",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.LOCATION}${id}/`;
    let formData = {
      ...values,
      parent: null,
      group: values.group?.map((item: any) => item.value),
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Country
        </span>
      </div>
      <EditCountryComponent
        isLoading={isPatchLoading}
        refetch={refetch}
        handleEdit={handleEdit}
        country={data}
      />
    </>
  );
};
export default EditCountry;
